import React, { useEffect } from 'react'
import Control from '../store/control';

// Set MPT
const FormAlign_1 = () => {
  // TODO: check warning later
  const SetCameraFront  = Control.Get("SetCameraFront");
  SetCameraFront()

  return null;
}
export default FormAlign_1;
